/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ToolsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 73 72"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2">
        <path d="M11.683 67.68a4.492 4.492 0 0 1-6.363 0 4.494 4.494 0 0 1 0-6.36l19.71-19.716 6.363 6.363-19.71 19.713z" />
        <path strokeLinecap="round" d="M21.853 38.421l12.72 12.726" />
        <path d="M60.25 12.75L28.186 44.814M63.802 16.299L56.377 8.88 67 1.5 71.5 6zM36.67 29.436L25.435 18.204c1.848-4.368 1.002-9.609-2.562-13.17C19.312 1.479 14.302.63 9.931 2.475L16 8.802V15H9.538L3.343 9.06c-1.848 4.374-.999 9.498 2.562 13.056 3.558 3.564 8.799 4.353 13.164 2.505l11.238 11.214M36.67 42.165l11.241 11.244c-1.848 4.368-1.002 9.606 2.562 13.167 3.561 3.558 8.799 4.404 13.17 2.559l-6.102-6.33v-6h6L70 62.769c1.848-4.368.999-9.606-2.562-13.164-3.561-3.564-8.799-4.413-13.167-2.562L43.036 35.802" />
      </g>
    </g>
  </svg>
);

export default ToolsIcon;
